const profileData = {
  userName: "Godfred Akpan",
  photoLink: "https://d1fdloi71mui9q.cloudfront.net/yuCFQn7pTM6h8CLaz4yg_P9EEwAdBx8V9feek",
  desc: "I believe great things comes to those who seek great things",
};

const themeData = {
  light: {
    backgroundColor: "white",
    onHoverBackgroundColor: "#dfe6e9",
    cardBackgroundColor: "#ffffff",
    onHoverTextColor: "#636e72",
    footerColor: "black",
    footerSocialLinkColor: "white",
    headerFontColor: "#black",
    CardtextColor: "#2d3436",
  },
  dark: {
    backgroundColor: "#000000",
    onHoverBackgroundColor: "#02040a",
    cardBackgroundColor: "#222222",
    onHoverTextColor: "white",
    footerColor: "white",
    footerSocialLinkColor: "white",
    headerFontColor: "white",
    CardtextColor: "white",
  },
};
const linkData = [
  {
    id: 1,
    link: "https://www.polywork.com/godfred_akpan",
    name: "Polywork",
    image:
      "",
  },
  {
    id: 2,
    link: "https://drive.google.com/file/d/1-sLJz4-dzP756q_qxe6WXs4AMZL8pTeF/view?usp=sharing",
    name: "Resume",
    image:
      "",
  },
  {
    id: 3,
    link: "https://github.com/godfredakpan",
    name: "Github",
    image:
      "",
  },
  {
    id: 4,
    link: "https://hrmaneja.com/",
    name: "Hr-Maneja Demo",
    image:
      "",
  },
  {
    id: 5,
    link: "https://irunauto.com/",
    name: "iRUN HQ",
    image:
      "",
  },
  {
    id: 6,
    link: "https://hrmaneja.com/",
    name: "Hr-Maneja",
    image:
      "",
  },
  {
    id: 7,
    link: "https://www.linkedin.com/in/godfredakpan/",
    name: "LinkedIn",
    image:
      "",
  },
  {
    id: 8,
    link: "https://twitter.com/godfredakpan",
    name: "Twitter",
    image:
      "",
  },
  {
    id: 9,
    link: "https://instagram.com/godfred.eth",
    name: "Instagram",
    image:
      "",
  },
  {
    id: 10,
    link: "https://web.facebook.com/godfred.akpan.14/",
    name: "Facebook",
    image:
      "",
  }
];

export { profileData, linkData, themeData };
